import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary:
          "bg-emerald-600 text-white hover:bg-emerald-700 active:bg-emerald-700",
        primaryDark:
          "dark:bg-emerald-600 dark:text-white dark:hover:bg-emerald-500 dark:active:bg-emerald-700",
        secondary:
          "bg-gray-200 text-gray-900 hover:bg-emerald-100 hover:text-emerald-900 active:bg-gray-400",
        secondaryDark:
          "dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 dark:active:bg-gray-800",
        ghost:
          "border border-gray-300 bg-white text-gray-900 hover:bg-white hover:text-emerald-700 hover:border-emerald-500 active:bg-gray-200",
        ghostDark:
          "dark:border dark:border-gray-600 dark:bg-transparent dark:text-white dark:hover:bg-gray-800 dark:active:bg-gray-700",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        xs: "text-xs h-7 px-2.5",
        sm: "text-sm h-8 px-3",
        default: "text-sm h-9 px-4",
        lg: "text-base h-10 px-6",
        xl: "text-lg h-12 px-8",
        icon: "h-10 w-10",
        iconSm: "h-8 w-8",
        iconLg: "h-12 w-12",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    (<Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />)
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }